import { z } from 'zod';

export const ChatSchema = z.object({
  title: z.string(),
  chat_id: z.string(),
  chat_history: z.array(z.array(z.string())),
  date: z.string(),
  starred: z.boolean().default(false),
});

export type Chat = z.infer<typeof ChatSchema>;
